<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import ContactDetailsContainer from 'dashboard/components-next/Contacts/Pages/ContactDetailsContainer.vue';

const route = useRoute();
const contactId = computed(() => route.params.contactId);
</script>

<template>
  <ContactDetailsContainer :contact-id="contactId" />
</template>
